<template>
  <transition name="banner">
    <div v-if="isVisible" class="briq-banner">
      <div class="briq-banner__inner">
        <div class="briq-banner__text" v-html="bannerHtml"></div>

        <button
          class="briq-banner__close"
          type="button"
          aria-label="Banner sluiten"
          @click="hideBanner"
        >
          ×
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import DOMPurify from 'dompurify'
import { marked } from 'marked'

export default {
  name: 'BriqBanner',

  data() {
    return {
      hiddenBannerText: sessionStorage.getItem('hiddenBannerText'),
    }
  },

  computed: {
    bannerText() {
      const bannerText =  this.$store.state?.briqState?.briqState?.bannerText 
      return bannerText || ''
    },

    isVisible() {
      return !!this.bannerText &&
        this.bannerText !== this.hiddenBannerText
    },

    bannerHtml() {
      return DOMPurify.sanitize(
        marked.parse(this.bannerText, { async: false })
      ).replace('<a', '<a target=\'_blank\'')
    },
  },

  methods: {
    hideBanner() {
      sessionStorage.setItem('hiddenBannerText', this.bannerText)
      this.hiddenBannerText = this.bannerText
    },
  },
}
</script>

<style scoped>
.briq-banner {
  position: relative;
  box-sizing: border-box;
  flex-shrink: 0;
  height: 48px;
  background: #ffc94b;
  color: #0f172a;
  font-size: 14px;
  text-align: center;
}

.briq-banner__inner {
  padding: 12px 40px;
}

.briq-banner__text >>> a {
  text-decoration: underline;
  color: #0F172A;
}
.briq-banner__text >>> p {
  margin: 0;
}

.briq-banner__close {
  position: absolute;
  right: 12px;
  top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}

.banner-enter-active,
.banner-leave-active {
  overflow: hidden;
  transition: height 300ms ease, opacity 300ms ease;
}

.banner-enter,
.banner-leave-to {
  height: 0;
  opacity: 0;
}
</style>